import { useEffect } from 'react';
import './MyTargetAd.css';

export const MyTargetAd = () => {
    useEffect(() => {
        (window as any).MRGtag = (window as any).MRGtag || [];
        (window as any).MRGtag.push({});
    }, []);

    return (
        <div className="my-target-ad">
            <ins
                className="mrg-tag"
                style={{ display: 'inline-block', width: 240, height: 400 }}
                data-ad-client="ad-2013672"
                data-ad-slot="2013672"
            />
        </div>
    );
};
